/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Batch_ExportInputs */



/**
* | output |
* | --- |
* | "Open the batch export menu" |
*
* @param {Shortcut_Keys_Desc_Batch_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_batch_export = /** @type {((inputs?: Shortcut_Keys_Desc_Batch_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Batch_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le menu d'exportation par lots")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapelexport-Menü öffnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri il menu di esportazione batch")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыть меню пакетного экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir el menú de exportación por lotes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开批量导出菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一括エクスポートメニューを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच निर्यात मेनू खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abrir o menu de exportação em lote")
	return /** @type {LocalizedString} */ ("Open the batch export menu")
});